import { Box, Typography, styled } from '@mui/material'

export const ProjectSectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  paddingBottom: theme.spacing(12),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(6),
    paddingBottom: theme.spacing(16),
  },
}))

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.overline,
  color: theme.palette.surface[50],
}))

export const ProjectHeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  flexDirection: 'column',
}))

export const LogoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '48px',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    height: '64px',
  },
}))

export const StatsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '400px',
  },
  [theme.breakpoints.up('lg')]: {
    position: 'absolute',
    right: 0,
    top: 60,
    gap: theme.spacing(4),
  },
}))

export const StatsWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  background: 'linear-gradient(0deg, rgba(41, 42, 46, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%)',
  border: `1px solid ${theme.palette.surface[700]}`,
  backdropFilter: 'blur(6px)',
  borderRadius: '12px',
  backgroundImage: `url('/assets/ourResults/graphism.svg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'bottom',
  backgroundRepeat: 'no-repeat',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}))

export const StatValue = styled(Typography)(({ theme }) => ({
  ...theme.typography.h3,
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h2,
  },
}))

export const StatDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
}))

export const ProjectDescription = styled(Box)(({ theme }) => ({
  ...theme.typography.subtitle1,
  maxWidth: '600px',
  marginLeft: 'auto',
  marginRight: 'auto',
  color: theme.palette.surface[50],
}))

export const StatWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))

export const ImageAndStatsContainer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column-reverse',
}))

export const ImageContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1000px',
  height: '300px',
  position: 'relative',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    height: '500px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '600px',
  },
}))

export const VideoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '600px',
  height: '185px',
  borderRadius: '12px',
  overflow: 'hidden',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    height: '338px',
  },
}))

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
}))
